import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
/** @preview ![icon](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGZpbGw9IiMxMTE5MjgiIGQ9Ik01IDExaDE0djJINXoiLz48L3N2Zz4=) */
export const IconMinus = forwardRef<HTMLElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path fill="#111928" d="M5 11h14v2H5z" />
    </Icon>
));
IconMinus.displayName = "IconMinus";
